import { Pipe, PipeTransform } from '@angular/core';

import { Guideline } from '@treetop/shared/model';

import { isConnectedGuideline } from '../connected-guideline.util';

@Pipe({ name: 'isConnectedGuideline' })
export class IsConnectedGuidelinePipe implements PipeTransform {
  public transform(guideline: Guideline): boolean {
    return isConnectedGuideline(guideline.guidelineOrigin);
  }
}
